export default {
  'aiConsumptions.title': 'AI Consumptions',
  'aiConsumptions.text.year': 'Year',
  'aiConsumptions.text.source': 'Source',
  'aiConsumptions.text.source.assistant': 'Assistant',
  'aiConsumptions.text.source.processactiontypeopenai': 'Process / Action OpenAI',
  'aiConsumptions.text.source.processactiontypeautomyai': 'Process / Action AUTOMY AI',
  'aiConsumptions.text.provider': 'Provider',
  'aiConsumptions.text.provider.openai': 'OpenAI',
  'aiConsumptions.text.family': 'Family',
  'aiConsumptions.text.inputTokens': 'Input Tokens',
  'aiConsumptions.text.inputTokensCache': 'Input Tokens (Cache)',
  'aiConsumptions.text.outputTokens': 'Output Tokens',
  'aiConsumptions.text.outputTokensReasoning': 'Output Tokens (Reasoning)',
  'aiConsumptions.text.totalTokens': 'Tokens',
  'aiConsumptions.text.finalPrice': 'Price',
  'aiConsumptions.text.model': 'Model',
  'aiConsumptions.text.processInstance': 'Request',
  'aiConsumptions.text.actionName': 'Action',
  'aiConsumptions.text.chatThread': 'Chat Thread',
  'aiConsumptions.text.connection': 'Connection',
};
